(ns machtfit.storage
  (:require [clojure.set :as set]
            [clojure.string :as str]
            [hodgepodge.core :refer [serialize deserialize get-item local-storage]]
            [machtfit.startpage.products-cache :as products-cache]
            [re-frame.core :as rf]))

;; The allowlist contains all relevant and currently used machtfit keys in the local storage.
;; All machtfit keys not included to the allow list will be removed from local storage.

;; An alternative aproach could be the registration of used keys into a known-keys atom.
;; local-storage-clean is then comparing with it.

;; (def known-keys (atom #{}))

;; (local-storage/register-key 'machtfit.app.stepchall.spectator-alert-dismissed?)

;; (defn register-key! [key]
;;   (swap! known-keys conj key))

(def ^:private local-storage-allow-list
  #{'machtfit.app.startpage.timestamp
    'machtfit.app.startpage.version
    'machtfit.app.startpage.products
    'machtfit.app.startpage.products-cache-key
    'machtfit.app.stepchall.spectator-alert-dismissed?
    'machtfit.app.stepchall.tracker-intro-dismissed?
    'machtfit.app.startpage.products-location
    'machtfit.app.startpage.dismissed-campaign-ids
    'machtfit.app.checkout-survey.last-closed
    'machtfit.app.checkout-survey.close-count
    'machtfit.app.checkout-survey.done
    'klaro})

(def ^:private local-storage-persist-list
  #{'klaro})

(defn- storage-put [data storage]
  (doseq [[k v] data]
    (try
      (assoc! storage k v)
      (catch js/DOMException e
        (js/console.warn "localStorage quota exceeded, skipping cache write." e)))))

(rf/reg-fx ::local-storage-put
  (fn [data]
    (storage-put data local-storage)))

(defn- is-machtfit? [k]
  (str/starts-with? k "machtfit."))

(defn- is-klaro? [k]
  (= k "klaro"))

(defn- is-machtfit-or-klaro? [k]
  (or (is-machtfit? k)
      (is-klaro? k)))

;; when the local storage is corrupt, an NS_ERROR_FILE_CORRUPTED error can be thrown,
;; in that case treat the whole storage as empty
(defn- storage-fetch [storage]
  (let [machtfit-relevant (try (for [i (range (count storage))
                                     :let [k (.key storage i)
                                           v (get-item storage k)]
                                     :when (is-machtfit-or-klaro? k)]
                                 (if (is-klaro? k)
                                   [k (-> v
                                          js/decodeURIComponent
                                          js/JSON.parse
                                          (js->clj :keywordize-keys true)
                                          serialize)]
                                   [k v]))
                               (catch js/Object _ ()))]
    (into {} (for [[k v] machtfit-relevant]
               [(deserialize k) (deserialize v)]))))

(defn items-to-clear [items-to-persist]
  (-> local-storage
      storage-fetch
      keys
      set
      (set/difference items-to-persist)))

(defn clear-local-storage []
  (doseq [item (items-to-clear local-storage-persist-list)]
    #_{:clj-kondo/ignore [:unused-value]}
    (dissoc! local-storage item)))

(rf/reg-fx
  ::local-storage-clear
  (fn [_]
    (clear-local-storage)))

(let [version (get-item local-storage "machtfit.app.startpage.version")]
  (if (and version (not= (int version) products-cache/current-version))
    (do (js/console.error "Clearing local storage!")
        (clear-local-storage))

    (doseq [item (items-to-clear local-storage-allow-list)]
      #_{:clj-kondo/ignore [:unused-value]}
      (dissoc! local-storage item))))

(rf/reg-cofx ::local-storage-fetch
  (fn [cofx] (assoc cofx :local-storage (storage-fetch local-storage))))
